export default __webpack_public_path__ + "static/2020-1-2c0e58483908cbd84002af2a5d5d6bbb.jpg";